export const STATUS_CONFIG = {
  incomplet: { label: 'Incomplet', dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-700' },
  incomplet_activation: { label: 'Incomplet activation', dot: 'bg-gray-300', bg: 'bg-gray-50', text: 'text-gray-600' },
  incomplet_j15: { label: 'Incomplet J+15', dot: 'bg-rose-400', bg: 'bg-rose-50', text: 'text-rose-700' },
  incomplet_j30: { label: 'Incomplet J+30', dot: 'bg-red-500', bg: 'bg-red-100', text: 'text-red-700' },
  pret_a_livrer: { label: 'Prêt à livrer', dot: 'bg-sky-400', bg: 'bg-sky-50', text: 'text-sky-700' },
  pret_a_livrer_stock: { label: 'Prêt à livrer - Stock m.', dot: 'bg-blue-300', bg: 'bg-blue-50', text: 'text-blue-600' },
  livre: { label: 'Livré', dot: 'bg-blue-700', bg: 'bg-blue-100', text: 'text-blue-800' },
  demande_envoyee: { label: 'Demande envoyé', dot: 'bg-yellow-400', bg: 'bg-yellow-50', text: 'text-yellow-700' },
  dem_docs_complem: { label: 'Dem. docs complem.', dot: 'bg-orange-500', bg: 'bg-orange-100', text: 'text-orange-700' },
  paiement_en_cours: { label: 'Paiement en cours', dot: 'bg-green-400', bg: 'bg-green-100', text: 'text-green-700' },
  paye_par_ne: { label: 'Payé par NE', dot: 'bg-sky-300', bg: 'bg-sky-50', text: 'text-sky-600' },
  litige_paiement: { label: 'Litige paiement', dot: 'bg-red-700', bg: 'bg-red-100', text: 'text-red-800' },
  facture_reglee: { label: 'Facture réglée', dot: 'bg-emerald-600', bg: 'bg-emerald-100', text: 'text-emerald-800' },
  annule: { label: 'Annulé', dot: 'bg-gray-500', bg: 'bg-gray-100', text: 'text-gray-600' },
};

export const INTERVENTION_STATUS_CONFIG = {
  a_planifier: { label: 'À planifier', dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-700' },
  assignee: { label: 'Assignée', dot: 'bg-orange-400', bg: 'bg-orange-50', text: 'text-orange-700' },
  en_cours: { label: 'En cours', dot: 'bg-blue-500', bg: 'bg-blue-50', text: 'text-blue-700' },
  terminee: { label: 'Terminée', dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  a_reassigner: { label: 'À réassigner', dot: 'bg-red-500', bg: 'bg-red-50', text: 'text-red-700' },
  annulee: { label: 'Annulée', dot: 'bg-gray-500', bg: 'bg-gray-100', text: 'text-gray-600' },
};

export const LIVRAISON_STATUS_CONFIG = {
  a_planifier: { label: 'À planifier', dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-700' },
  planifiee: { label: 'Planifiée', dot: 'bg-blue-400', bg: 'bg-blue-50', text: 'text-blue-700' },
  livree: { label: 'Livrée', dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
};

export const STATUTS_LIST = Object.entries(STATUS_CONFIG).map(([value, cfg]) => ({ value, ...cfg }));

export const MODELES = [
  { value: 'KLOSS', label: 'KLOSS - Fauteuil coiffure électrique' },
  { value: 'PUSH', label: 'PUSH CLUB RG77 - Siège de coupe électrique' },
];

export const MODES_REGLEMENT = ['virement', 'cheque', 'especes', 'prelevement', 'autre'];

export const STATUTS_CARSAT = [
  { value: 'en_attente', label: 'En attente' },
  { value: 'envoye', label: 'Envoyé' },
  { value: 'docs_complementaires', label: 'Docs complémentaires demandés' },
  { value: 'en_instruction', label: 'En instruction' },
  { value: 'accepte', label: 'Accepté' },
  { value: 'subvention_recue', label: 'Subvention reçue' },
  { value: 'refuse', label: 'Refusé' },
];
